import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';
import { black, grey500 } from 'styles/colors';

export const Wrapper = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
`;

export const Main = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: auto;
`;

export const ChartWrapper = styled.div`
	padding: 0 32px;
	display: flex;
	flex-direction: column;
`;

export const Title = styled.div`
	font-style: normal;
	font-weight: 500;
	font-size: 23px;
	line-height: 31px;
	letter-spacing: 0.3px;
	color: ${colors.grey7};
	display: flex;
	padding: 16px 0 0 0;
`;

export const LoaderWrapper = styled.div`
	width: 100%;
	text-align: center;
	padding: 15% 0;
`;

export const AnalysisWrapper = styled.div`
	margin: ${props => (props.index === '0' ? '1% 0 2%' : '0 0 1%')}
	border: 1px solid #878787;`;

// overflow-y: ${props => (props.isExpanded ? 'scroll' : 'unset')};
// height: ${props => (props.isExpanded ? '400px' : '111px')};

export const TableContainer = styled.table`
	width: 100%;
`;

export const TableHead = styled.thead`
	text-align: left;
	position: sticky;
	top: 0;
	z-index: 1;
	background: #ffffff;
`;

export const TableRow = styled.tr``;

export const TableCellGroup = styled.th`
	padding: 8px 0 8px 7px;
`;

export const TableCellPeerCount = styled.th`
	width: 8%;
	padding: 14px 5px;
	text-align: center;
`;

export const TableCellMin = styled.th`
	padding: 14px 5px;
	text-align: center;
`;

export const TableCellClassification = styled.th`
	width: 9%;
	padding: 14px 5px;
	text-align: center;
`;

export const TableCellChart = styled.th`
	width: 30%;
	padding: 0 30px;
`;

export const TableCellMax = styled.th`
	width: ${props => (props.showClassifications ? '7%' : '10%')};
	padding: 14px 5px;
	text-align: center;
`;

export const TableBody = styled.tbody`
	background-color: ${colors.grey200};
`;

export const FiltersWrapper = styled.tbody`
	display: flex;
	align-items: center;
	margin: 20px 20px 20px 0px;
`;

export const DateRangeWrapper = styled.div`
	.ap-month-picker > div:nth-child(2) {
		top: 0;
		right: 50%;
	}
`;
export const MetadataSummaryLine = styled.tr`
	vertical-align: middle;
`;

export const SummaryLabel = styled.td`
	color: ${grey500};
	font-size: 16px;
	line-height: 32px;
	font-weight: normal;
	padding: 12px 64px 12px 12px;
`;

export const SummaryValue = styled.td`
	color: ${black};
	font-size: 16px;
	font-weight: 500;
	line-height: 32px;
	display: flex;
	align-items: flex-start;
	padding: 8px 0;
	height: 56px;
`;

export const FlexCenterText = styled.div`
	display: flex;
	justify-content: center;
`;
